<template>
    <CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
            <form id="FormArticulosWeb" class="form-horizontal" method="post" autocomplete="off" onSubmit="return false">
                <div class="container-fluid">
                    <div class="form-group form-row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                            <label for="">Nombre</label>
                            <input placeholder="Nombre" type="text" class="form-control" v-model="ObjArticuloWeb.Nombre">
                        </div>
                    </div>
                    <div class="form-group form-row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                            <label for="">Clave</label>
                            <input placeholder="Clave" type="text" class="form-control" v-model="ObjArticuloWeb.Clave">
                        </div>
                    </div>

                    <div class="row form-group">
                        <h6>Cuenta con:</h6>
                        
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                            <div class="form-check-inline form-check form-switch form-sw">
                                <input v-model="ObjArticuloWeb.ReqTratExt" class="form-check-input" role="switch" type="checkbox" id="ReqTratExt">
                                <label class="form-check-label" for="ReqTratExt">Recubrimiento Externo</label>
                            </div>
                        </div>
                        
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                            <div class="form-check-inline form-check form-switch form-sw">
                                <input v-model="ObjArticuloWeb.ReqTratInt" class="form-check-input" role="switch" type="checkbox" id="ReqTratInt">
                                <label class="form-check-label" for="ReqTratInt">Recubrimiento Interno</label>
                            </div>
                        </div>
                    </div>

                    <div class="row form-group">
                        <h6>Requiere Parámetros:</h6>

                        <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                            <div class="form-check-inline form-check form-switch form-sw">
                                <input v-model="ObjArticuloWeb.AnguloPantoscopico" class="form-check-input" role="switch" type="checkbox" id="AnguloPantoscopico">
                                <label class="form-check-label" for="AnguloPantoscopico">Angulo Pantoscópico</label>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                            <div class="form-check-inline form-check form-switch form-sw">
                                <input v-model="ObjArticuloWeb.AnguloPanoramico" class="form-check-input" role="switch" type="checkbox" id="AnguloPanoramico">
                                <label class="form-check-label" for="AnguloPanoramico">Angulo Panoramico</label>
                            </div>
                        </div>

                        <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                            <div class="form-check-inline form-check form-switch form-sw">
                                <input v-model="ObjArticuloWeb.DistanciaVertice" class="form-check-input" role="switch" type="checkbox" id="DistanciaVertice">
                                <label class="form-check-label" for="DistanciaVertice">Distancia al Vertice</label>
                            </div>
                        </div>

                        <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                            <div class="form-check-inline form-check form-switch form-sw">
                                <input v-model="ObjArticuloWeb.DistanciaLectura" class="form-check-input" role="switch" type="checkbox" id="DistanciaLectura">
                                <label class="form-check-label" for="DistanciaLectura">Distancia de Lectura</label>
                            </div>
                        </div>

                        <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                            <div class="form-check-inline form-check form-switch form-sw">
                                <input v-model="ObjArticuloWeb.Iniciales" class="form-check-input" role="switch" type="checkbox" id="Iniciales">
                                <label class="form-check-label" for="Iniciales">Iniciales</label>
                            </div>
                        </div>

                       <!--<div class="col-12 col-sm-6 col-md-6 col-lg-6">
                            <div class="form-check-inline form-check form-switch form-sw">
                                <input v-model="ObjArticuloWeb.ReqAltSeg" class="form-check-input" role="switch" type="checkbox" id="ReqAltSeg">
                                <label class="form-check-label" for="ReqAltSeg">Alto de Segmento</label>
                            </div>
                        </div> -->

                    </div>
                </div>
            </form>
        </template>
    </CLoader>
</template>
<script>
export default{
    name: 'FormArticuloWeb',
    props: ['poBtnSave'],
    data(){
        return{
            ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            ObjArticuloWeb: {
                IdArticuloWeb:0,
                IdSublinea:0,
				IdTipoLente: 0,
                Nombre:'',
                Clave:'',
                ReqTratamiento:false,
                ReqTratExt:false,
                ReqTratInt:false,
                AnguloPantoscopico:false,
                AnguloPanoramico:false,
                DistanciaVertice:false,
                DistanciaLectura:false,
                Iniciales:false,
                ReqAltSeg:false
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion
        }
    },
    methods:{
        async Guardar(){
            this.poBtnSave.DisableBtn = true;
            let formData=new FormData();
            formData.set('IdSublinea',this.ObjArticuloWeb.IdSublinea);
            formData.set('IdTipoLente',this.ObjArticuloWeb.IdTipoLente);
            formData.set('Nombre',this.ObjArticuloWeb.Nombre);
            formData.set('Clave',this.ObjArticuloWeb.Clave);

            formData.set('ReqTratamiento',this.ObjArticuloWeb.ReqTratamiento ? 'SI' : 'NO');
            formData.set('ReqTratExt',this.ObjArticuloWeb.ReqTratExt ? 'SI' : 'NO');
            formData.set('ReqTratInt',this.ObjArticuloWeb.ReqTratInt ? 'SI' : 'NO');
            
            formData.set('AnguloPantoscopico',this.ObjArticuloWeb.AnguloPantoscopico ? 'SI' : 'NO');
            formData.set('AnguloPanoramico',this.ObjArticuloWeb.AnguloPanoramico ? 'SI' : 'NO');
            formData.set('DistanciaVertice',this.ObjArticuloWeb.DistanciaVertice ? 'SI' : 'NO');
            formData.set('DistanciaLectura',this.ObjArticuloWeb.DistanciaLectura ? 'SI' : 'NO');
            formData.set('Iniciales',this.ObjArticuloWeb.Iniciales ? 'SI' : 'NO');
            formData.set('ReqAltSeg',this.ObjArticuloWeb.ReqAltSeg ? 'SI' : 'NO');
            formData.set('ReqEjeAdd',this.ObjArticuloWeb.ReqEjeAdd);
            
            if (this.ObjArticuloWeb.IdArticuloWeb==0) {
                await this.$http.post('articulosweb',formData).then((res)=>{
                    this.EjecutaConExito(res);
                }).catch((err)=>{
                    this.EjecutaConError(err);
                });   
            }
            else{
                await this.$http.post('articulosweb/'+this.ObjArticuloWeb.IdArticuloWeb,formData).then((res)=>{
                    this.EjecutaConExito(res);
                }).catch((err)=>{
                    this.EjecutaConError(err);
                }); 
            }
        },
        EjecutaConExito(res){
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err){
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
        Limpiar(){
            this.ObjArticuloWeb={
                IdArticuloWeb:0,
                IdSublinea:0,
				IdTipoLente: 0,
                Nombre:'',
                Clave:'',
                ReqTratamiento:false,
                ReqTratExt:false,
                ReqTratInt:false,
                AnguloPantoscopico:false,
                AnguloPanoramico:false,
                DistanciaVertice:false,
                DistanciaLectura:false,
                Iniciales:false,
                ReqAltSeg:false
            }
            this.errorvalidacion=[];
        },
        async Recuperar(){
            await this.$http.get('articulosweb/'+this.ObjArticuloWeb.IdArticuloWeb).then((res)=>{
                this.ObjArticuloWeb                     = res.data.data;
                this.ObjArticuloWeb.ReqTratamiento      = this.ObjArticuloWeb.ReqTratamiento =='SI' ? true : false;
                this.ObjArticuloWeb.ReqTratExt          = this.ObjArticuloWeb.ReqTratExt =='SI' ? true : false;
                this.ObjArticuloWeb.ReqTratInt          = this.ObjArticuloWeb.ReqTratInt =='SI' ? true : false;
                this.ObjArticuloWeb.AnguloPantoscopico  = this.ObjArticuloWeb.AnguloPantoscopico =='SI' ? true : false;
                this.ObjArticuloWeb.AnguloPanoramico    = this.ObjArticuloWeb.AnguloPanoramico =='SI' ? true : false;
                this.ObjArticuloWeb.DistanciaVertice    = this.ObjArticuloWeb.DistanciaVertice =='SI' ? true : false;
                this.ObjArticuloWeb.DistanciaLectura    = this.ObjArticuloWeb.DistanciaLectura =='SI' ? true : false;
                this.ObjArticuloWeb.Iniciales           = this.ObjArticuloWeb.Iniciales =='SI' ? true : false;
                this.ObjArticuloWeb.ReqAltSeg           = this.ObjArticuloWeb.ReqAltSeg =='SI' ? true : false;
                this.ObjArticuloWeb.ReqEjeAdd           = this.ObjArticuloWeb.ReqEjeAdd;

            }).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
            });
        }
    },
    created(){
        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$off('Save_'+this.Emit);
    },
    mounted(){
        this.bus.$on('Recovery_'+this.Emit,(Id,Obj)=>{
            // console.log(Obj);
            this.ConfigLoad.ShowLoader=true;
            this.Limpiar();
            this.ObjArticuloWeb.IdArticuloWeb=Id;
            this.ObjArticuloWeb.IdTipoLente=Obj.IdTipoLente;
            this.ObjArticuloWeb.IdSublinea=Obj.IdSublinea;
            if (this.ObjArticuloWeb.IdArticuloWeb>0) {
                this.Recuperar();
            }
            else{
                this.ConfigLoad.ShowLoader=false;
            }
            this.bus.$on('Save_'+this.Emit,()=>{
                this.Guardar();
            });
        });
    }
}
</script>